<script>
export default {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  render(h, context) {
    const { icon, title } = context.props;
    const vnodes = [];

    if (icon) {
      let iconName = "iconfont iconMaright " + icon;
      vnodes.push(<i class={iconName}></i>);
    }

    if (title) {
      if (title == "首页") {
        vnodes.push(<span class="shouye">{title}</span>);
      } else {
        vnodes.push(<span>{title}</span>);
      }
    }
    return vnodes;
  },
};
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/leftMenu/Item.vue